module.exports = __webpack_public_path__ + "static/media/mindfulness.6f26343e.png";